/**
 * tdesign v1.11.4
 * (c) 2025 tdesign
 * @license MIT
 */

import './useConfig.mjs';
import { EAnimationType } from '../config-provider/utils/context.mjs';
import { useConfig } from '../config-provider/hooks/useConfig.mjs';
import 'vue';
import 'lodash-es';
import '../_chunks/dep-99da72b8.mjs';
import '../_chunks/dep-6da93342.mjs';
import '../_chunks/dep-b0ea6825.mjs';
import '../_chunks/dep-2705c570.mjs';
import '../_chunks/dep-bc824998.mjs';
import '../config-provider/type.mjs';

var expand = EAnimationType.expand,
  ripple = EAnimationType.ripple,
  fade = EAnimationType.fade;
function useKeepAnimation() {
  var _useConfig = useConfig("animation"),
    globalConfig = _useConfig.globalConfig;
  var keepAnimation = function keepAnimation(type) {
    var _animationConfig$excl, _animationConfig$incl;
    var animationConfig = globalConfig.value;
    return animationConfig && !((_animationConfig$excl = animationConfig.exclude) !== null && _animationConfig$excl !== void 0 && _animationConfig$excl.includes(type)) && ((_animationConfig$incl = animationConfig.include) === null || _animationConfig$incl === void 0 ? void 0 : _animationConfig$incl.includes(type));
  };
  return {
    keepExpand: keepAnimation(expand),
    keepRipple: keepAnimation(ripple),
    keepFade: keepAnimation(fade)
  };
}

export { useKeepAnimation as default };
//# sourceMappingURL=useKeepAnimation.mjs.map
